/**
 * Modal - Componente de modal reutilizável
 */
import { useEffect, useCallback } from 'react'
import { createPortal } from 'react-dom'

export default function Modal({
  isOpen,
  onClose,
  title,
  subtitle,
  icon,
  size = 'medium',
  children,
  footer,
  hideCloseButton = false,
  closeOnOverlayClick = true,
}) {
  const handleEscape = useCallback(
    (e) => {
      if (e.key === 'Escape') onClose()
    },
    [onClose]
  )

  useEffect(() => {
    if (isOpen) {
      document.addEventListener('keydown', handleEscape)
      document.body.style.overflow = 'hidden'
    }
    return () => {
      document.removeEventListener('keydown', handleEscape)
      document.body.style.overflow = ''
    }
  }, [isOpen, handleEscape])

  if (!isOpen) return null

  return createPortal(
    <div className="modal-overlay" onClick={closeOnOverlayClick ? onClose : undefined}>
      <div
        className={`modal-container modal-${size}`}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal-header">
          <div className="modal-title-area">
            {icon && <i className={`fas ${icon} modal-icon`} />}
            <div>
              <h2 className="modal-title">{title}</h2>
              {subtitle && <p className="modal-subtitle">{subtitle}</p>}
            </div>
          </div>
          {!hideCloseButton ? (
            <button className="modal-close" onClick={onClose}>
              <i className="fas fa-times" />
            </button>
          ) : null}
        </div>
        <div className="modal-body">{children}</div>
        {footer && <div className="modal-footer">{footer}</div>}
      </div>
    </div>,
    document.body
  )
}

/**
 * ConfirmModal - Modal de confirmação
 */
export function ConfirmModal({
  isOpen,
  onClose,
  title = 'Confirmar',
  message,
  onConfirm,
  confirmText = 'Sim',
  cancelText = 'Não',
}) {
  const handleConfirm = () => {
    onConfirm()
    onClose()
  }

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      icon="fa-question-circle"
      size="small"
      footer={
        <>
          <button className="btn btn-outline" onClick={onClose}>
            {cancelText}
          </button>
          <button className="btn btn-danger" onClick={handleConfirm}>
            {confirmText}
          </button>
        </>
      }
    >
      <p>{message}</p>
    </Modal>
  )
}
